











































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { CreteMember,UpdateMember,QueryActivityAllList,QueryMemberAllList} from '@/api'
import { ElForm } from 'element-ui/types/form'
import { VTable, TableHander } from '@/components/table'
import { VImageUpload } from '@/components/upload'
import { TxLocal } from '@/utils/local/TxLocal'

@Component({
  components: {
    VTable,
    VImageUpload,
  },
})
export default class EditShopDialog extends Vue {
  @Prop({ type: Boolean, default: false }) private appendToBody!: boolean

  @Emit('close')
  private close() {
    const f = this.$refs.form as ElForm
    f.resetFields()
    this.data = {

    }
    this.show = false
  }
  private data: any = {

  }
  private show = false
  private isEdit = false
  private activitList: Array<any> = []
  private memberList: Array<any> = []




  public async open(data: any, isEdit: boolean) {
    this.show = true
    this.data = {...this.data,...data}
    if (Array.isArray(this.data.activityIds) && this.data.activityIds.length) {
      this.data.activityIds = this.data.activityIds.filter((id: number) => id != null && id > 0)
    } else if (this.data.activityId != null && this.data.activityId > 0) {
      this.data.activityIds = [this.data.activityId]
    } else {
      this.data.activityIds = []
    }
    this.isEdit = isEdit
    // 加载绑定商品
     QueryActivityAllList().then(res=>{
      this.activitList = res
    })
    QueryMemberAllList().then(res=>{
      this.memberList = res
    })

    if (this.data.icon) {
      this.data.iconList = this.data.icon.split(',').map((e: string) => {
        return { url: e }
      })
    } else {
      this.data.iconList = []
    }
  }

  private requiredRule = { required: true, message: '不能为空', trigger: 'blur' }
  private rules = {
    name: [this.requiredRule],
    icon: [this.requiredRule],
    isDemotion: [this.requiredRule],
    contributionNumber: [this.requiredRule],
    sequence: [this.requiredRule],
    level: [this.requiredRule],
  }

  public async save() {

    this.data.icon = this.data.iconList.map((e: any) => e.url).join(',')
    if (!Array.isArray(this.data.activityIds)) {
      this.data.activityIds = []
    }

    const form = this.$refs.form as ElForm
    form.validate(async (valid: boolean) => {
      if (valid) {
        console.log(this.data)
        let result = {}
        if(this.isEdit){
          result = await UpdateMember(this.data)
        } else {
          result = await CreteMember(this.data)
        }
        if(result){
          this.close()
        }

      } else {
        this.$message.error("表单存在错误，不能保存")
        return false
      }
    })
  }
}
